import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { GRID_BREAKPOINT_L, GRID_BREAKPOINT_S, Link, MAX_CONTENT_WIDTH } from 'modules/UI';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${tokens.colors.grayLight};
`;

export const Limiter = styled.div`
  min-height: 343px;
  padding: 0 ${tokens.space.regular};
  max-width: ${MAX_CONTENT_WIDTH};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media screen and (max-width: ${GRID_BREAKPOINT_L}) {
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
  }
`;

export const Title = styled.div`
  font-family: ${tokens.fonts.primary};
  font-weight: 100;
  font-size: 42px;
  line-height: 64px;
  color: ${tokens.colors.black};
  max-width: 900px;

  ${tokens.mediaQueries.s} {
    font-size: ${tokens.fontSizes.l};
    line-height: ${tokens.lineHeights.l};
    padding: ${tokens.space.larger} 0;
  }

  @media screen and (max-width: ${GRID_BREAKPOINT_L}) {
    display: flex;
    align-items: center;
    text-align: center;
    height: 100%;
    padding: 60px 0;
  }
`;

export const Actions = styled.div`
  display: grid;
  height: 100%;
  align-items: center;
  grid-template-rows: repeat(3, 1fr);
  justify-items: center;

  @media screen and (max-width: ${GRID_BREAKPOINT_L}) {
    grid-template-rows: unset;
    height: 80px;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    padding-bottom: ${tokens.space.regular};
  }

  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    grid-template-columns: unset;
    height: unset;
    grid-template-rows: repeat(3, 1fr);
  }
`;

export const Filler = styled.div`
  @media screen and (max-width: ${GRID_BREAKPOINT_S}) {
    display: none;
  }
`;

export const ActionLink = styled(Link)`
  font-size: ${tokens.fontSizes.m};
  line-height: ${tokens.lineHeights.l};
  align-self: self-end;
  display: flex;
  align-items: center;
`;
